import { textToId } from "$lib/utilities/dom-helpers";

export const getTotalNumberOfSelectedFilters = (activeFilters = []) => {
  return activeFilters.reduce((accumulator, currentFilterGroup) => {
    currentFilterGroup.bodyProps.options.forEach((option) => {
      if (option.isChecked === true) {
        accumulator++;
      }
    });
    return accumulator;
  }, 0);
};

export const filterOutInactiveFilterGroups = (filterGroups) => {
  return filterGroups.filter((filterGroup) => {
    return filterGroup.bodyProps.options.some((option) => {
      return option.isChecked;
    });
  });
};

/**
 * transform applied filter groups to active filters
 *
 * @param {*} selectedFilterGroups
 * @returns
 */
export const flattenAppliedFilterGroups = (selectedFilterGroups) =>
  selectedFilterGroups.reduce((selectedOptions, currentFilterGroup) => {
    currentFilterGroup.bodyProps.options.forEach((option) => {
      if (option.isChecked) {
        selectedOptions.push(option);
      }
    });
    return selectedOptions;
  }, []);

/**
 * transform tag groups into list of filters
 *
 * @param {TagGroups} tagGroups
 */
export function tagGroupsToFilters(tagGroups = {}) {
  return Object.entries(tagGroups).map(([type, tags]) => ({
    fields: {
      name: type,
      tags: tags.map((tag) => ({
        fields: {
          name: tag,
          type
        }
      }))
    }
  }));
}

export const setQueryParamsFromFilters = (filters = [], pageUrl) => {
  const newUrl = new URL(pageUrl);
  const params = new URLSearchParams(newUrl.search);

  filters.forEach((filterGroup) => {
    const selectedOptions = filterGroup.bodyProps.options
      .filter((option) => option.isChecked)
      .map((option) => option.label);

    if (selectedOptions.length > 0) {
      params.set(textToId(filterGroup.headline), selectedOptions.map(encodeURIComponent).join(","));
    } else {
      params.delete(textToId(filterGroup.headline));
    }
  });

  history.replaceState({}, "", `${newUrl.pathname}${params.size > 0 ? "?" : ""}${params}`);
};

export const getFiltersFromQueryParams = (filters = [], pageUrl) => {
  const params = new URLSearchParams(pageUrl);

  return filters.map((filterGroup) => {
    const paramValue = params.get(textToId(filterGroup.headline));

    if (paramValue) {
      const selectedOptions = paramValue.split(",").map(decodeURIComponent);

      filterGroup.bodyProps.options = filterGroup.bodyProps.options.map((option) => {
        return {
          ...option,
          isChecked: selectedOptions.includes(option.label)
        };
      });
    }

    return filterGroup;
  });
};
